import { render, staticRenderFns } from "./MemberListAddNew.vue?vue&type=template&id=0b3ed25b&"
import script from "./MemberListAddNew.vue?vue&type=script&lang=js&"
export * from "./MemberListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberListAddNew.vue?vue&type=style&index=0&id=0b3ed25b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports